import React from 'react';
import closei from '../../assets/image/x-square.svg';

const Button = ({ button, type, onClick, loader, disabled, className, add, close, icon, id }) => {
	return (
		<div id={id}>
			<button
				type={type}
				className={`w-100 btn btn-lg font-14 m-0 ${className}`}
				onClick={onClick}
				disabled={disabled}
			>
				{loader && <i className="fa fa-refresh fa-spin"></i>}
				{add && (
					<i
						className="fa fa-plus"
						style={{
							strokeWidth: '.1rem',
							WebkitTextStrokeColor: 'var(--brand-color)',
							'-webkit-text-stroke-width': '1px',
							marginLeft: '0.5rem',
						}}
					></i>
				)}
				{close && (
					<img
						alt="close"
						src={closei}
						style={{}}
					/>
				)}
				{icon && (
					<img
						alt="close"
						src={icon}
						style={{}}
					/>
				)}
				<span
					style={{
						paddingLeft:
							(loader && button) || (add && button) || (close && button) || (icon && button)
								? '10px'
								: '0px',
					}}
				>
					{button}
				</span>
			</button>
		</div>
	);
};

export default Button;
